

import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {

}
},
methods: {
goBack(){
this.$router.push({
path : '/developer/index',
query : {}
})
},
download(){
alert("请移步至PC端操作");
}
}
}



// WEBPACK FOOTER //
// ./src/views/doc/resourceDownload.vue